<template>
  <div fluid v-if="this.ticket" class="mt-4">
    <b-row fluid  class="text-left">
      <b-col lg="8" class="order-lg-12">
        <b-container fluid>
          <b-row class="mb-3 border-bottom border-secondary">
            <b-col cols="7" class="pl-0">
              <h4>Descripció de la incidència</h4>
            </b-col>
            <b-col cols="5" class="pr-0 text-right">
              <span v-if="this.ticket.propers_estats.find(estat => estat.trigger == 'reactivate')" >
                <b-button class="mr-1" size="sm" variant="danger" @click="reactivate()">
                  Reobrir
                  <font-awesome-icon :icon="['fas', 'exclamation-triangle']"/>
                </b-button>
                <AddAction v-if="checkUserInTicket(this.user, ticket)"
                transition="reactivate" :ticket="this.ticket" title="Perquè la vols reobrir?"/>
              </span>
              <span v-else-if="this.ticket.estat.nom == 'pending' &&
                checkTicketEditable(this.user, this.ticket) && checkManagerInGroup(this.user, this.ticket.grup.id)">
                <b-button class="mr-1" size="sm" variant="primary" v-b-modal.modalCategoryGroupIncidence>
                  Reassignar
                  <font-awesome-icon :icon="['fas', 'edit']"/>
                </b-button>
                <ReassignModal :ticket="this.ticket"/>
              </span>
              <b-button size="sm" class="mr-1" v-if="checkTicketEditable(this.user, this.ticket) && checkManagerInGroup(this.user, this.ticket.grup.id)"
              @click="cancelTicket()" variant="danger">
                Anul·lar
                <font-awesome-icon :icon="['fas', 'times']"/>
              </b-button>
              <AddAction v-if="checkTicketEditable(this.user, this.ticket) && checkManagerInGroup(this.user, this.ticket.grup.id)"
                transition="cancel" :ticket="this.ticket" title="Perquè la vols anul·lar?" modalRef="cancelModal"/>
            </b-col>
          </b-row>
          <b-form-row class="mb-4">
            <label class="font-weight-bold">
              {{ this.ticket.categoria.descripcio }} > {{ this.ticket.grup.descripcio }} > {{ this.ticket.incidencia.descripcio }}
            </label>
          </b-form-row>
          <b-form-row class="mb-4">
            <h4 style="white-space: pre-wrap">{{ this.ticket.detalls }}</h4>
          </b-form-row>
          <b-row class="mb-3 border-bottom border-secondary">
            <b-col cols="7" class="pl-0">
              <h4>Historial de la incidència</h4>
            </b-col>
            <b-col cols="5" class="pr-0 text-right">
              <b-button size="sm" class="mr-1" v-if="checkTicketEditable(this.user, this.ticket) && checkManagerInGroup(this.user, this.ticket.grup.id)"
              v-b-modal.modalSendEmail variant="primary">
                Enviar correu
                <font-awesome-icon :icon="['far', 'envelope']"/>
              </b-button>
              <b-modal id="modalSendEmail" centered ref="modalSendEmail" title="S'enviarà el següent correu als usuaris:">
                <ReadOnlyEditor :editorText="this.emailText"/>
                <div slot="modal-footer" class="w-100">
                  <b-btn size="sm" class="float-right" variant="primary" @click.prevent="sendEmail()" >
                    <font-awesome-icon :icon="['fas', 'check']"/>
                    Enviar
                  </b-btn>
                </div>
              </b-modal>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col class="pl-0">
              <TicketHistory :ticket="this.ticket" :files="this.actions_files"/>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
      <b-col lg="4" class="order-lg-1">
        <b-container fluid>
          <b-row class="mb-3 border-bottom border-secondary">
            <b-col class="pl-0">
              <h4>Detalls</h4>
            </b-col>
            <b-col class="pr-0">
              <SaveDetails class="text-right mr-1"
              :ticket="this.ticket"
              :transition="this.transition"
              :newTicketAssigned="this.newTicketAssigned"
              :priority="this.priority"
              v-if="this.checkManagerInGroup(this.user, this.ticket.grup.id) && managerModifyStateShown(ticket)"/>
            </b-col>
          </b-row>
          <b-form-row>
            <label class="font-weight-bold">Id incidència:</label>
            <span class="ml-2">
              {{ this.ticket.id }}
            </span>
          </b-form-row>
          <b-form-row>
            <label class="font-weight-bold">Data de creació:</label>
            <span class="ml-2">
              {{ this.ticket.data_creacio }}
            </span>
          </b-form-row>
          <b-form-row v-if="this.ticket.aula">
            <label class="font-weight-bold">Aula:</label>
            <span class="ml-2">{{ this.ticket.aula }}</span>
          </b-form-row>
          <b-form-row v-if="this.checkManagerInGroup(this.user, this.ticket.grup.id)">
            <label class="font-weight-bold">Temps total dedicat:</label>
            <span class="ml-2">{{ this.ticket.temps_total_dedicat | format_time() }}</span>
          </b-form-row>
          <b-form-row>
            <label class="mr-sm-2 font-weight-bold">Estat:</label>
            <ChangeState class="mb-2"
            @updateTransition="childVal => {
              transition = childVal
            }"
            @updateNewTicketAssigned="childVal => {
              newTicketAssigned = childVal
            }"
            v-if="checkManagerInGroup(this.user, this.ticket.grup.id) && managerModifyStateShown(ticket)"
            :ticket="this.ticket"/>
            <span v-else>{{ this.ticket.estat.displayname }}</span>
          </b-form-row>
          <b-form-row v-if="checkTicketEditable(this.user, this.ticket) && checkManagerInGroup(this.user, this.ticket.grup.id)">
            <label class="mr-sm-2 font-weight-bold">Prioritat:</label>
            <ChangePriority :ticket="this.ticket"
            @updatePriority="childVal => {
              priority = childVal
            }"/>
          </b-form-row>
          <b-form-row v-if="checkManagerInGroup(this.user, this.ticket.grup.id)">
            <label class="font-weight-bold">Temp previst:</label>
            <span class="ml-2">{{ this.ticket.temps_previst }}</span>
          </b-form-row>

          <b-row class="mb-3 mt-3 border-bottom border-secondary">
            <b-col class="pl-0">
              <h4>Usuaris</h4>
            </b-col>
            <b-col class="pr-0">
              <AddUser v-if="checkTicketEditable(this.user, this.ticket)" class="text-right mr-1" :ticket="this.ticket"/>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <UserCard v-for="u in this.ticket.usuaris" :key="u.codi_xarxa" :user="u" :ticket="ticket"
            :user_type="'User'" :editable="checkTicketEditable(user, ticket) && checkManagerInGroup(user, ticket.grup.id)"/>
          </b-row>

          <b-row class="mb-3 border-bottom border-secondary">
            <b-col class="pl-0">
              <h4>Gestors</h4>
            </b-col>
            <b-col class="pr-0">
              <AddManager class="text-right mr-1"
              v-if="checkTicketEditable(this.user, this.ticket) && checkManagerInGroup(this.user, this.ticket.grup.id)"
              :ticket="this.ticket"/>
            </b-col>
          </b-row>
          <b-row class="mb-3" v-if="this.ticket.gestors.length > 0">
            <UserCard v-for="g in this.ticket.gestors" :key="g.codi_xarxa" :user="g" :ticket="ticket"
            :user_type="'Manager'" :editable="checkTicketEditable(user, ticket) && checkManagerInGroup(user, ticket.grup.id)"/>
          </b-row>
          <b-form-row v-else>
            <label class="font-weight-bold">No hi han gestors seguint la incidència.</label>
          </b-form-row>
          <b-row class="mb-3 border-bottom border-secondary">
            <b-col class="pl-0">
              <h4>Fitxers adjunts</h4>
            </b-col>
          </b-row>
          <FileManagement class="mb-2" :ticket="this.ticket" :files="this.user_files"/>
        </b-container>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AddAction from '@/components/AddAction'
import AddManager from '@/components/AddManager'
import AddUser from '@/components/AddUser'
import ChangePriority from '@/components/ChangePriority'
import ChangeState from '@/components/ChangeState'
import FileManagement from '@/components/FileManagement'
import SaveDetails from '@/components/SaveDetails'
import TicketHistory from '@/components/TicketHistory'
import UserCard from '@/components/UserCard'
import ReadOnlyEditor from '@/components/ReadOnlyEditor'
import ReassignModal from '@/components/ReassignModal'

export default {
  components: {
    AddAction,
    AddManager,
    AddUser,
    ChangePriority,
    ChangeState,
    FileManagement,
    TicketHistory,
    SaveDetails,
    UserCard,
    ReassignModal,
    ReadOnlyEditor
  },
  computed: {
    actions_files () {
      const actionsFilesNames = this.$store.state.ticket.accions.flatMap(action => action.files)
      return this.files.filter(file => actionsFilesNames.includes(file.name))
    },
    user_files () {
      const actionsFilesNames = this.$store.state.ticket.accions.flatMap(action => action.files)
      return this.files.filter(file => !actionsFilesNames.includes(file.name))
    },
    ticket () {
      return this.$store.state.ticket
    },
    user () {
      return this.$store.getters.getUser
    },
    files () {
      return this.$store.state.files
    }
  },
  filters: {
    format_time: function (value) {
      var timeArray = value.split(':')
      var formatted = `${timeArray[0]}h ${timeArray[1]}min ${timeArray[2]}s`
      return formatted
    },
    truncate: function (value, limit) {
      if (value && value.length > limit) {
        value = value.substring(0, (limit - 3)) + '...'
      }
      return value
    }
  },
  data () {
    return {
      emailText: '',
      transition: null,
      newTicketAssigned: null,
      priority: null
    }
  },
  created () {
    this.$store.dispatch('fetchTicket', this.$route.params.id).then(() => {
      this.emailText = `<p>Bon dia,</p>
        <p><b>${this.$store.getters.getUser.id}</b> ha afegit informació a la teva incidència.</p>
        <p>Pots accedir al següent enllaç:</p>
        <a href='https://apps.escoladeltreball.org/tiquets/tiquet/${this.ticket.id}'>
        apps.escoladeltreball.org/tiquets/tiquet/${this.ticket.id}
        </a>
        <p><b>Aquest missatge ha estat generat automàticament. Si us plau no respongueu.</b></p>`
    }).catch(e => {
      if ([403, 404].includes(e.status)) {
        this.$router.push({ name: 'Error', params: { 'code': e.status } })
      }
    })
  },
  methods: {
    reactivate () {
      // Si es un usuari en reobrir ha de demanar info, si es gestor no cal
      if (this.checkUserInTicket(this.user, this.ticket)) {
        this.$bvModal.show('modalAddAction')
      } else {
        var data = {
          ticket_id: this.ticket.id,
          codi_xarxa: this.$store.getters.getUser.id,
          transition: 'reactivate'
        }
        this.$store.dispatch('managerTransitionTicket', data)
      }
    },
    sendEmail () {
      this.$store.dispatch('managerSendEmail', {
        ticket_id: this.ticket.id,
        user: this.$store.getters.getUser.id
      }).then(() => { this.$refs['modalSendEmail'].hide() })
    },
    cancelTicket () {
      this.$bvModal.show('cancelModal')
    }
  }
}
</script>

<style scoped>
</style>
